import { api } from "./api";
import type {
  JobListItem,
  JobDetail,
  JobCreateRequest,
  JobManualCreateRequest,
  JobPatchRequest,
  AnalysisResponse,
} from "../types";

export const jobsService = {
  list: () => api.get<JobListItem[]>("/api/jobs"),

  createFromUrl: (data: JobCreateRequest) =>
    api.post<JobDetail>("/api/jobs", data),

  createManual: (data: JobManualCreateRequest) =>
    api.post<JobDetail>("/api/jobs/manual", data),

  get: (id: string) => api.get<JobDetail>(`/api/jobs/${id}`),

  update: (id: string, data: JobPatchRequest) =>
    api.patch<JobDetail>(`/api/jobs/${id}`, data),

  delete: (id: string) => api.delete<void>(`/api/jobs/${id}`),

  analyze: (id: string) => api.post<AnalysisResponse>(`/api/jobs/${id}/analyze`),
};
